import useRequest from '@/websdk/utils/request';
export default (function () {
  const { data } = useRequest({
    name: 'GET_VERSION',
    url: `/api/version`,
  });
  return data;
});
